import {Storage} from "./Storage";

// const logResponse = async (url, requestData, response) => {
//     console.group('Fetch Detailed Report');
//     console.log('apiFetch response:', url, requestData);
//     const logClone = response.clone();
//     const data = await logClone.json();
//
//     console.log('URL:', response.url);
//     console.log('Status:', response.status, response.statusText);
//     console.log('OK:', response.ok);
//     console.log('Type:', response.type); // e.g., 'cors', 'basic'
//
//     // Transform Headers into a readable object
//     const headers = {};
//     response.headers.forEach((value, key) => {
//         headers[key] = value;
//     });
//     console.log('Headers:', headers);
//     console.log('Body:', data);
//     console.groupEnd();
// };

export const apiFetch = async (url, data = {}) => {
    // console.log('apiFetch: ', url, data);
    return fetch(url, {
        ...data,
        headers: {
            ...(data.headers || {}),
            'X-Auth-Token': await Storage.getItem('token')
        }
    })
        // .then(async response => {
        //     await logResponse(url, data, response);
        //     return response;
        // })
        ;
}
